import(/* webpackMode: "eager" */ "/home/ubuntu/download_production/6a92f1e66d471300141a48c8_1788261451098_c302c262/learnforex/src/app/how-it-works/page.tsx");
